/**
 * @description 差错对账
 */

import RECONCILIATION from '@/api/module/reconciliation';

const ERROR = {
  namespaced: true,

  state: {
    // 对账详情---差错详情
    errTableData: [],
    // 差错列表
    tableData: [],
    // 这是 map 数据
    rightListMap: {
      // eslint-disable-next-line
      '累计差错数': {text: 1000, unit: '条'},
      // eslint-disable-next-line
      '待处理差错数': {text: 1000, unit: '条'},
    },
    params: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }, //翻页
    errDetailTable: {},
  },
  mutations: {
    // 差错对账详情
    seterrTableData(state, data = {}) {
      data.map(item => {
        item.channelTradeState = item.channelTradeState === 'REFUND' ? '退款账单' : '支付账单';
        item.processingState = item.processingState === 0 ? '待处理' : '已处理';
        item.errorType = item.errorType === 1 ? '平台漏单' : '状态不符';
      });
      state.errTableData = data;
    },
    // 设置差错列表
    settableData(state, data = {}) {
      data.records.map(item => {
        item.channel = item.channel === 'WECHAT' ? '微信' : item.channel === 'ALIPAY' ? '支付宝' : '银联';
        item.processingState = item.processingState === 0 ? '待处理' : '已处理';
      });
      for (let key in state.rightListMap) {
        if (key === '累计差错数') {
          state.rightListMap[key].text = data.total;
        } else {
          state.rightListMap[key].text = data.current;
        }
      }
      state.tableData = data.records;
      state.params.total = data.total;
    },
    // 对账详情
    seterrDetailTable(state, data = {}) {
      data.channel = data.channel === 'WECHAT' ? '微信' : data.channel === 'ALIPAY' ? '支付宝' : '银联';
      data.processingState = data.processingState === 0 ? '待处理' : '已处理';
      data.channelTradeState = data.channelTradeState === 'REFUND' ? '已退款' : '已支付';
      for (let key in data) {
        if (
          key === 'platformOrderAmount' ||
          key === 'platformShouldAmount' ||
          key === 'platformPayAmount' ||
          key === 'channelOrderAmount' ||
          key === 'channelShouldAmount' ||
          key === 'channelPayAmount'
        ) {
          data[key] = data[key] ? data[key].toFixed(2) : '暂无';
        }
      }
      state.errDetailTable = data;
    },
  },
  actions: {
    // 对账详情---差错对账详情
    async getFailDetail({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.getFailList(params);
        commit('seterrTableData', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改差错对账状态
    async changeFailStatus({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.updateFailStatus(params);
        commit(result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取差错对账列表
    async queryErrorList({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.getErrorList(params);
        commit('settableData', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取差错对账详情
    async getErrorDetail({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.getErrorDetails(params);
        commit('seterrDetailTable', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    errTableData: state => state.errTableData,
    tableData: state => state.tableData,
    rightListMap: state => state.rightListMap,
    params: state => state.params,
    errDetailTable: state => state.errDetailTable,
  },
};

export default ERROR;
